const finishTabStyle = {
  padding20: {
    padding: 20,
  },
}

export default finishTabStyle
